console.info(`
At Way2Web Software, we're always looking for new talent.
We develop "next level software" for companies that want to keep on pushing forward.
If you'd like to join, please have a look at our career opportunities.
`);
